
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/addUnassignedMenu';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.add_unassigned_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.add_unassigned_menu.add_unassigned_student", "Add Unassigned Student", options) : helperMissing.call(depth0, "t", "groups.manage.add_unassigned_menu.add_unassigned_student", "Add Unassigned Student", options)))
    + "\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.add_unassigned_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.add_unassigned_menu.add_unassigned_user", "Add Unassigned User", options) : helperMissing.call(depth0, "t", "groups.manage.add_unassigned_menu.add_unassigned_user", "Add Unassigned User", options)))
    + "\n  ";
  return buffer;
  }

  buffer += "<div class=\"popover-title\">\n  ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<div class=\"popover-content\">\n  <div class=\"form-search clearfix\">\n    <input\n      type=\"text\"\n      name=\"search_term\"\n      class=\"search-query\"\n      data-view=\"inputFilter\"\n      placeholder='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.add_unassigned_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.add_unassigned_menu.search_people", "Search people", options) : helperMissing.call(depth0, "t", "groups.manage.add_unassigned_menu.search_people", "Search people", options)))
    + "'\n      aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.add_unassigned_menu")
  },data:data},helper ? helper.call(depth0, "groups.manage.add_unassigned_menu.search_people", "Search people", options) : helperMissing.call(depth0, "t", "groups.manage.add_unassigned_menu.search_people", "Search people", options)))
    + "'\n      role=\"search\"\n    >\n  </div>\n  <div data-view=\"users\"></div>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '19',
      bundle: 'jst/groups/manage/addUnassignedMenu'
    });
  ;
    export default templates[name];
  